export default function ChevronIcon({
  className = '',
  width = '12',
  height = '7',
}) {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 12 7">
      <path
        d="M5.575 6.55C5.44167 6.55 5.31233 6.525 5.187 6.475C5.06167 6.425 4.95767 6.35833 4.875 6.275L0.275 1.675C0.0916663 1.49167 0 1.25833 0 0.974999C0 0.691666 0.0916663 0.458333 0.275 0.275C0.458333 0.0916663 0.691667 0 0.975 0C1.25833 0 1.49167 0.0916663 1.675 0.275L5.575 4.175L9.475 0.275C9.65833 0.0916663 9.89167 0 10.175 0C10.4583 0 10.6917 0.0916663 10.875 0.275C11.0583 0.458333 11.15 0.691666 11.15 0.974999C11.15 1.25833 11.0583 1.49167 10.875 1.675L6.275 6.275C6.175 6.375 6.06667 6.446 5.95 6.488C5.83333 6.53 5.70833 6.55067 5.575 6.55Z"
        fill="currentColor"
      />
    </svg>
  );
}
